import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

import type { IFatEventApi, LightweightEvent } from './model';

export function fatEventApiConnector(http$: IHttpClient): IFatEventApi {
  return {
    getFatEvent<T>(lightEvent: LightweightEvent, useAdvisory?: boolean): Observable<T> {
      const { uri } = lightEvent;

      return http$
        .getJSON<T>({
          url: uri,
          targetHost: useAdvisory ? 'AdvisoryBridge' : 'SpBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
    getFatEventWithTabId<T>(lightEvent: LightweightEvent, tabId: string): Observable<T> {
      const { uri } = lightEvent;
      const uriWithTabId = !uri.includes('?') ? `${uri}?tabId=${tabId}` : `${uri}&tabId=${tabId}`;
      return http$
        .getJSON<T>({
          url: uriWithTabId,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
